import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { selectCurrentLights } from './lights-store/lights.selector';
import { LightsComponent } from './lights.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-lights',
  templateUrl: './lights.container.html',
  imports: [LightsComponent],
})
export class LightsContainerComponent {
  private readonly store = inject(Store);

  public readonly lights = this.store.selectSignal(selectCurrentLights);
}
